<!-- =========================================================================================
  File Name: TheCustomizer.vue
  Description: Template Customizer
  Component Name: TheCustomizer
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="theme-customizer">

    <div>
      <div class="h-full">

        <div class="customizer-header mt-6 flex items-center justify-between px-6">
<!--          <div>-->
<!--            <h4>THEME CUSTOMIZER</h4>-->
<!--            <small>Customize & Preview in Real Time</small>-->
<!--          </div>-->
<!--          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>-->
        </div>

        <vs-divider class="mb-0" />

        <component :is="scrollbarTag" class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
          <vx-card class="mb-base" >
            <!-- Change Logo -->
            <vs-row vs-w="12" class="ml-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <div class="vx-row">
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Logo</h5>
                    <vs-input type="hidden"/>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <!--   <vs-button @click="updateThemeTitle" class="mr-6">Submit</vs-button>-->

              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="ml-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <div class="vx-row">
                  <div class="vx-col flex-2">
                    <div class="img-container mb-4">
                      <img v-if="appLogo" :src="img_cdn+appLogo" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Logo
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="appLogo" @click="removeUploadedLogo">
                          Remove Logo
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <!--   <vs-button @click="updateThemeTitle" class="mr-6">Submit</vs-button>-->
                <vs-button @click.stop="saveAppSetting(dataKey='app_logo')" class="mr-16">Save</vs-button>
              </vs-col>
            </vs-row>


            <vs-divider/>
            <!-- Change Title -->
            <vs-row vs-w="12" class="ml-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <div class="vx-row">
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Logo Title</h5>
                    <vs-input v-model="setTitle" class="mt-5  ag-width-half" name="App-title" v-validate="'required'"/>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <!--   <vs-button @click="updateThemeTitle" class="mr-6">Submit</vs-button>-->
                <vs-button @click.stop="saveAppSetting(dataKey='set_title')" class="mr-16">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <!-- top Bar Title -->
            <vs-row vs-w="12" class="ml-6">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <div class="vx-row">
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Top Bar Title</h5>
                    <vs-input v-model="setTopBarTitle" class="mt-5  ag-width-half" name="App-title" v-validate="'required'"/>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="6">
                <!--   <vs-button @click="updateThemeTitle" class="mr-6">Submit</vs-button>-->
                <vs-button @click.stop="saveAppSetting(dataKey='top_bar_title')" class="mr-16">Save</vs-button>
              </vs-col>
            </vs-row>
          </vx-card>
          <vx-card class="mb-base">
            <!-- Layout Type -->
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Layout</h5>
                    <h5 class="mb-4"></h5>
                    <div>
                      <vs-radio v-model="layoutType" vs-value="vertical" class="mr-4" vs-name="layout-type-vertical">
                        Vertical
                      </vs-radio>
                      <vs-radio v-model="layoutType" vs-value="horizontal" class="mr-4"
                                vs-name="layout-type-horizontal">
                        Horizontal
                      </vs-radio>
                    </div>

                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveAppSetting(dataKey='change_layout')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <!-- THEME COLORS -->
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <div class="vx-col flex-2">
                    <div>
                      <h5 class="mb-4">Theme Color</h5>
                      <ul class="clearfix">

                        <!-- Color Square -->
                        <li
                          v-for="color in themeColors"
                          :key="color"
                          :style="{backgroundColor: color}"
                          :class="{'shadow-outline': color == primaryColor}"
                          class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"
                          @click="updatePrimaryColor(color)"/>

                        <!-- Custom Color Square -->
                        <li
                          :style="{backgroundColor: customPrimaryColor}"
                          :class="{'shadow-outline': customPrimaryColor == primaryColor}"
                          class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"
                          @click="updatePrimaryColor(customPrimaryColor)"/>
                        <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2"
                                                      v-model="customPrimaryColor" type="color"/></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveAppSetting(dataKey='theme_color')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <!-- THEME MODE-->
            <vs-row vs-w="12" class="ml-1">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="2" vs-sm="8" vs-xs="7">
                <div class="vx-row">
                  <div class="vx-col flex-2">


                    <h5 class="mb-2">Theme Mode</h5>

                    <vs-radio v-model="themeMode" vs-value="light" class="mr-4" vs-name="theme-mode-light">Light
                    </vs-radio>
                    <vs-radio v-model="themeMode" vs-value="dark" class="mr-4" vs-name="theme-mode-dark">Dark</vs-radio>
                    <vs-radio
                      v-if="layoutType === 'vertical'"
                      v-model="themeMode"
                      vs-value="semi-dark"
                      vs-name="theme-mode-semi-dark">Semi Dark
                    </vs-radio>


                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="0" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveAppSetting(dataKey='theme_mode')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <!-- COLLAPSE SIDEBAR -->
<!--            <vs-row vs-w="12">-->
<!--              <vs-col vs-type="flex"  vs-align="center" vs-lg="2" vs-sm="4" vs-xs="7">-->
<!--                <div class="vx-row">-->

<!--                  <template v-if="layoutType === 'vertical'">-->

<!--                    <h5 class="ml-8">Collapse Sidebar</h5>-->
<!--                  </template>-->
<!--                </div>-->
<!--              </vs-col>-->

<!--              &lt;!&ndash; Hidden center column &ndash;&gt;-->
<!--              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="0">-->
<!--              </vs-col>-->
<!--              &lt;!&ndash; save button &ndash;&gt;-->
<!--              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">-->
<!--                &lt;!&ndash;                <vs-button @click="" class="mr-6">Save</vs-button>&ndash;&gt;-->
<!--                <vs-switch v-if="layoutType === 'vertical'"-->
<!--                           v-model="reduced_sidebar" @input="saveAppSetting(dataKey='collapse_sidebar')"/>-->
<!--              </vs-col>-->

<!--            </vs-row>-->
<!--           <br>-->
<!--            <vs-divider/>-->

            <!-- DAILYT LOGIN ATTEMPTS -->
            <vs-row vs-w="12">
              <vs-col vs-type="flex"  vs-align="start" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                    <h5 class="ml-6">Max Daily Logins Feature</h5>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <!--                <vs-button @click="" class="mr-6">Save</vs-button>-->
                <!--                <vs-switch @input="saveAppSetting(dataKey='max_daily_login_feature')"-->
                <!--                           v-model="enableDailyLoginAttempts"/>-->
                <vs-switch v-model="enableDailyLoginAttempts"/>
              </vs-col>
            </vs-row>


          </vx-card>
          <vx-card class="mb-base">
            <!-- Layout Type -->
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Login Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataLoginImage" :src="img_cdn+dataLoginImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateLoginPageInput" @change="updateLoginPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateLoginPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataLoginImage" @click="removeUploadedImage(key='login_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='login_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Register Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataRegisterImage" :src="img_cdn+dataRegisterImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateRegisterPageInput" @change="updateRegisterPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateRegisterPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataRegisterImage" @click="removeUploadedImage(key='register_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='register_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Verify Email Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataVerifyEmailImage" :src="img_cdn+dataVerifyEmailImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateVerifyEmailrPageInput" @change="updateVerifyEmailPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateVerifyEmailrPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataVerifyEmailImage" @click="removeUploadedImage(key='verify_email_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='verify_email_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Forgot Password Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataForgotPasswordImage" :src="img_cdn+dataForgotPasswordImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateForgotPasswordPageInput" @change="updateForgotPasswordPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateForgotPasswordPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataForgotPasswordImage" @click="removeUploadedImage(key='forgot_password_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="start" vs-align="start" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='forgot_password_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Reset Password Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataResetPasswordImage" :src="img_cdn+dataResetPasswordImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateResetPasswordPageInput" @change="updateResetPasswordPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateResetPasswordPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataResetPasswordImage" @click="removeUploadedImage(key='reset_password_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="start" vs-align="start" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='reset_password_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="7">
                <div class="vx-row">
                  <!-- Layout Type -->
                  <div class="vx-col flex-2">
                    <h5 class="mb-2">Change Resend Token Page Image</h5>
                    <br>
                    <div class="img-container mb-4">
                      <img v-if="dataResendTokenImage" :src="img_cdn+dataResendTokenImage" class="rounded w-full"/>
                    </div>
                    <div class="img-container mb-4">
                      <!-- Image upload Buttons -->
                      <div class="modify-img flex justify-between mt-5">
                        <input type="file" class="hidden" ref="updateResendTokenPageInput" @change="updateResendTokenPageImg"
                               accept="image/*">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateResendTokenPageInput.click()">Update Image
                        </vs-button>
                        <vs-button type="flat" color="#999" v-if="dataResendTokenImage" @click="removeUploadedImage(key='resend_token_page_image')">
                          Remove Image
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </vs-col>
              <!-- Hidden center column -->
              <vs-col vs-type="flex" vs-justify="start" vs-align="start" vs-lg="7" vs-sm="4" vs-xs="0">
              </vs-col>
              <!-- save button -->
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="5">
                <vs-button @click.stop="saveImageSetting(dataKey='resend_token_page_image')" class="mr-6">Save</vs-button>
              </vs-col>
            </vs-row>
            <vs-divider/>


          </vx-card>


        </component>
      </div>
    </div>
  </div>
</template>


<script>
import themeConfig from '@/../themeConfig.js'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_IMAGE_SETTING, SAVE_APP_SETTING, UPLOAD_IMAGE} from "@/graphql";

export default {
  props: {
    // footerType       : { type: String,  required: true },
    // hideScrollToTop  : { type: Boolean, required: true },
    // navbarType       : { type: String,  required: true },
    // navbarColor      : { type: String,  required: true, default: '#fff' },
    // routerTransition : { type: String,  required: true }
  },
  data () {
    return {
      dataLoginImage: '',
      dataRegisterImage: '',
      dataVerifyEmailImage: '',
      dataForgotPasswordImage: '',
      dataResetPasswordImage: '',
      dataResendTokenImage: '',
      setSelectColor : '',
      dataImg: '',
      showRemoveLogoButon: true,
      isNavbarDark: false,
      navbarType: themeConfig.navbarType || 'floating',
      navbarColor: themeConfig.navbarColor || '#fff',
      hideScrollToTop: themeConfig.hideScrollToTop,
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      dynamicWatchers: {},
      active: true,
      enableDailyLoginAttempts:true,
      customPrimaryColor: '#3DC9B3',
      customNavbarColor: '#3DC9B3',
      routerTransitionsList: [
        {text: 'Zoom Fade', value: 'zoom-fade'},
        {text: 'Slide Fade', value: 'slide-fade'},
        {text: 'Fade Bottom', value: 'fade-bottom'},
        {text: 'Fade', value: 'fade'},
        {text: 'Zoom Out', value: 'zoom-out'},
        {text: 'None', value: 'none'}
      ],
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      ImgName: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      themeColors: ['#4a0d66', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    layoutType (val) {

      // Reset unsupported options
      if (val === 'horizontal') {
        if (this.themeMode === 'semi-dark') this.themeMode = 'light'
        if (this.navbarType === 'hidden')   this.navbarTypeLocal = 'floating'
        this.$emit('updateNavbarColor', '#fff')
      }
    }
  },
  computed: {
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    footerTypeLocal: {
      get ()    { return this.footerType },
      set (val) { this.$emit('updateFooter', val) }
    },
    hideScrollToTopLocal: {
      get ()    { return this.hideScrollToTop },
      set (val) { this.$emit('toggleHideScrollToTop', val) }
    },
    navbarColorInitial () {
      return this.$store.state.theme === 'dark' ? '#10163a' : '#fff'
    },
    navbarColorOptionClasses () {
      return (color) => {
        const classes = {}
        if (color === this.navbarColorLocal)   classes['shadow-outline'] = true
        if (this.navbarTypeLocal === 'static') classes['cursor-not-allowed'] = true
        return classes
      }
    },
    navbarColorLocal: {
      get () { return this.navbarColor },
      set (val) {
        if (this.navbarType === 'static') return
        this.updateNavbarColor( val)
      }
    },
    // navbarColorLocal: {
    //   get ()    { return this.$store.state.navbarColor },
    //   set (val) { this.$store.commit('UPDATE_NAV_BAR_COLOR', val) }
    // },
    navbarTypeLocal: {
      get() {
        return this.navbarType
      },
      set(val) {
        this.$emit('updateNavbar', val)
      }
    },
    layoutType: {
      get() {
        return this.$store.state.mainLayoutType
      },
      set(val) {
        this.$store.commit('UPDATE_MAIN_LAYOUT_TYPE', val)
      }
    },
    setTitle: {
      get() {
        return this.$store.state.themeTitle
      },
      set(val) {
        this.$store.commit('UPDATE_APP_TITLE', val)
      }
    },
    setTopBarTitle: {
      get() {
        return this.$store.state.topBarTitle
      },
      set(val) {
        this.$store.commit('UPDATE_APP_TOP_BAR_TITLE', val)
      }
    },
    appLogo: {
      get() {
        return this.$store.state.themeLogo
      },
      set(val) {
        this.$store.dispatch('UpdateAppLogo', val)
      }
    },


    primaryColor: {
      get() {
        return this.$store.state.themePrimaryColor
      },
      set(val) {
        this.$store.commit('UPDATE_PRIMARY_COLOR', val)
      }
    },
    reduced_sidebar: {
      get() {
        return this.$store.state.reduceButton
      },
      set(val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
      }
    },
    routerTransitionLocal: {
      get ()    { return this.routerTransition },
      set (val) { this.$emit('updateRouterTransition', val) }
    },
    rtl: {
      get ()    { return this.$vs.rtl },
      set (val) { this.$vs.rtl = val  }
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
    scrollbarTag () { return this.$store.state.is_touch_device ? 'div' : 'VuePerfectScrollbar' },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },

  methods: {
    removeUploadedLogo() {
        this.dataImg=''
        this.showRemoveLogoButon = false
        this.$store.dispatch('UpdateAppLogo', null)

    },
    removeUploadedImage(key) {
      if(key=='login_page_image'){
        this.dataLoginImage=''
      }
      if(key=='register_page_image'){
        this.dataRegisterImage=''
      }
      if(key=='verify_email_page_image'){
        this.dataVerifyEmailImage=''
      }
      if(key=='forgot_password_page_image'){
        this.dataForgotPasswordImage=''
      }
      if(key=='reset_password_page_image'){
        this.dataResetPasswordImage=''
      }
      if(key=='resend_token_page_image'){
        this.dataResendTokenImage=''
      }

    },
    // updateCurrImg(input) {
    //   if (input.target.files && input.target.files[0]) {
    //     const reader = new FileReader()
    //     reader.onload = e => {
    //       this.dataImg = e.target.result
    //       this.showRemoveLogoButon = true
    //
    //
    //       this.$store.dispatch('UpdateAppLogo', e.target.result)
    //
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //
    //
    //   }
    // },

    updateNavbar(val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    updatePrimaryColor(color) {
      this.primaryColor = color
      this.$vs.theme({primary: color})
    },
    successUpload() {
      this.$vs.notify({color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur'})
    },
    updateCurrImg(input) {

      if (input.target.files && input.target.files[0]) {
        this.checkImg = "somthing"
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result

          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: this.dataImg,
                oldimage: this.oldimage,
              }
            })
            .then(response => {
              if (response) {
                this.oldimage = ''
                if (response.data.uploadImage.status == "SUCCESS") {
                 var get_image_name = response.data.uploadImage.image_name.substring(6);
                  this.ImgName = get_image_name
                  // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                  this.$store.dispatch('UpdateAppLogo', this.ImgName)

                } else {
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateLoginPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataLoginImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateRegisterPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataRegisterImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateVerifyEmailPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataVerifyEmailImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateForgotPasswordPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataForgotPasswordImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateResetPasswordPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataResetPasswordImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateResendTokenPageImg(input) {

      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          // this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image: e.target.result
              }
            })
            .then(response => {

              if (response.data.uploadImage.status == "SUCCESS") {
                var get_image_name = response.data.uploadImage.image_name.substring(6);
                this.dataResendTokenImage = get_image_name
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')

              } else {
                this.UploadFail(response.data.uploadImage.error)
                // this.$vs.loading.close('#div-with-loading > .con-vs-loading')
              }


            }).catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    UploadFail(status) {
      this.$vs.notify({
        title: "Error",
        text: status,
        color: 'danger',
        position: 'top-right'
      })
    },
    saveAppSetting(datakey) {
      // alert(this.reduced_sidebar)
      this.$apollo
        .mutate({
          mutation: SAVE_APP_SETTING,
          variables: {
            key: datakey,
            value: (datakey == 'app_logo') ? this.ImgName :
              datakey == 'set_title' ? this.setTitle :
              datakey == 'top_bar_title' ? this.setTopBarTitle :
                datakey == 'change_layout' ? this.layoutType :
                  datakey == 'theme_color' ? this.primaryColor :
                    datakey == 'theme_mode' ? this.themeMode :
                      datakey == 'collapse_sidebar' ? this.reduced_sidebar :
                        datakey == 'max_daily_login_feature' ? this.enableDailyLoginAttempts : "0"
          }
        })
        .then(response => {
          if (response.data.saveAppSettings.status=='SUCCESS' || response.data.saveAppSettings.status=='UPDATED'){
            this.StatusSuccess()

          }
        }) .catch(error => {
        console.log(error)
      });
    },
    saveImageSetting(datakey) {
      // alert(this.reduced_sidebar)
      this.$apollo
        .mutate({
          mutation: SAVE_APP_SETTING,
          variables: {
            key: datakey,
            value: (datakey == 'login_page_image') ? this.dataLoginImage :
              datakey == 'register_page_image' ? this.dataRegisterImage :
                datakey == 'verify_email_page_image' ? this.dataVerifyEmailImage :
                  datakey == 'forgot_password_page_image' ? this.dataForgotPasswordImage :
                    datakey == 'reset_password_page_image' ? this.dataResetPasswordImage :
                      datakey == 'resend_token_page_image' ? this.dataResendTokenImage :
                        datakey == 'max_daily_login_feature' ? this.enableDailyLoginAttempts : "0"
          }
        })
        .then(response => {
          if (response.data.saveAppSettings.status=='SUCCESS' || response.data.saveAppSettings.status=='UPDATED'){
            this.StatusSuccess()

          }
        }) .catch(error => {
        console.log(error)
      });
    },
    StatusSuccess() {
      this.$vs.notify({
        title: "Setting",
        text: 'Saved Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    getThemeSettings() {
      this.$apollo
        .query({
          query: GET_IMAGE_SETTING,
        })
        .then(response => {
          if (response.data.getImagesSetting.login_page_image != null) {
            this.dataLoginImage = response.data.getImagesSetting.login_page_image
          } if (response.data.getImagesSetting.register_page_image != null) {
            this.dataRegisterImage = response.data.getImagesSetting.register_page_image
          }if (response.data.getImagesSetting.verify_email_page_image != null) {
            this.dataVerifyEmailImage = response.data.getImagesSetting.verify_email_page_image
          }if (response.data.getImagesSetting.forgot_password_page_image != null) {
            this.dataForgotPasswordImage = response.data.getImagesSetting.forgot_password_page_image
          }if (response.data.getImagesSetting.reset_password_page_image != null) {
            this.dataResetPasswordImage = response.data.getImagesSetting.reset_password_page_image
          }if (response.data.getImagesSetting.resend_token_page_image != null) {
            this.dataResendTokenImage = response.data.getImagesSetting.resend_token_page_image
          }
        })
        .catch(error => {
          console.log(error)
        });
    },
  },
  components: {
    VuePerfectScrollbar,
    themeConfig
  },

  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.dataImg = this.appLogo

    if(this.$store.state.themePrimaryColor ==undefined){
      this.setSelectColor = '#4a0d66'
    }
    else{
      this.setSelectColor = this.primaryColor
    }
    this.$store.commit('UPDATE_PRIMARY_COLOR', this.setSelectColor)


    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
    this.getThemeSettings()
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }

}

</script>


<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
  }
}

.customizer-btn {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;

  .vs-icon {
    animation: spin 1.5s linear infinite;
  }
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>

